let globalDefaultText = "Add to Cart"
let globalDefaultPrice = 0
let globalDefaultComparePrice = 0
let globalDefaultLabel = ""
let currentDefaultLabel = ""
let lastLabelType = "global"

const localeMap = {
  USD: "en-US",    // United States Dollar
  EUR: "de-DE",    // Euro (Germany format)
  GBP: "en-GB",    // British Pound Sterling
  CAD: "en-CA",    // Canadian Dollar
  AUD: "en-AU",    // Australian Dollar
  JPY: "ja-JP",    // Japanese Yen
  CNY: "zh-CN",    // Chinese Yuan
  INR: "en-IN",    // Indian Rupee
  KRW: "ko-KR",    // South Korean Won
  SGD: "en-SG",    // Singapore Dollar
  HKD: "zh-HK",    // Hong Kong Dollar
  NZD: "en-NZ",    // New Zealand Dollar
  MXN: "es-MX",    // Mexican Peso
  BRL: "pt-BR",    // Brazilian Real
  CHF: "de-CH",    // Swiss Franc
  SEK: "sv-SE",    // Swedish Krona
  NOK: "nb-NO",    // Norwegian Krone
  DKK: "da-DK",    // Danish Krone
  PLN: "pl-PL",    // Polish Złoty
  CZK: "cs-CZ",    // Czech Koruna
  HUF: "hu-HU",    // Hungarian Forint
  RUB: "ru-RU",    // Russian Ruble
  TRY: "tr-TR",    // Turkish Lira
  ZAR: "en-ZA",    // South African Rand
  THB: "th-TH",    // Thai Baht
  MYR: "ms-MY",    // Malaysian Ringgit
  PHP: "en-PH",    // Philippine Peso
  IDR: "id-ID",    // Indonesian Rupiah
  VND: "vi-VN",    // Vietnamese Đồng
  ILS: "he-IL",    // Israeli New Shekel
  AED: "ar-AE",    // UAE Dirham
  SAR: "ar-SA",    // Saudi Riyal
  QAR: "ar-QA",    // Qatari Riyal
  KWD: "ar-KW",    // Kuwaiti Dinar
  BHD: "ar-BH",    // Bahraini Dinar
  OMR: "ar-OM",    // Omani Rial
  JOD: "ar-JO",    // Jordanian Dinar
  LBP: "ar-LB",    // Lebanese Pound
  EGP: "ar-EG",    // Egyptian Pound
  CLP: "es-CL",    // Chilean Peso
  COP: "es-CO",    // Colombian Peso
  PEN: "es-PE",    // Peruvian Sol
  ARS: "es-AR",    // Argentine Peso
  UYU: "es-UY",    // Uruguayan Peso
  RON: "ro-RO",    // Romanian Leu
  BGN: "bg-BG",    // Bulgarian Lev
  HRK: "hr-HR",    // Croatian Kuna
  RSD: "sr-RS"     // Serbian Dinar
}

function formatPrice(cents) {
  const dollars = parseInt(cents) / 100
  const currency = window.Shopify.currency.active
  const locale = localeMap[currency] || 'en-US'
  
  const isWholeNumber = cents % 100 === 0

  return dollars.toLocaleString(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: isWholeNumber ? 0 : undefined
  }).split(".")[0]
}

function setPrice(price, comparePrice, label) {
  globalDefaultPrice = price
  globalDefaultComparePrice = comparePrice
  if (label) {
    currentDefaultLabel = label
    lastLabelType = "custom"
  } else {
    currentDefaultLabel = globalDefaultLabel
    lastLabelType = "global"
  }

  document.querySelectorAll("buy-button").forEach(btn => {
    btn.updateFromAttributes?.()
  })

  price = parseInt(price)
  comparePrice = comparePrice ? parseInt(comparePrice) : 0

  document.querySelectorAll(".ante-price:not(.static):not(.ante-buy-button-price)").forEach(priceEl => {
    const comparePriceEl = priceEl.querySelector(".ante-buy-compare-price")
    const priceSpanEl = priceEl.querySelector(".ante-buy-price")
    const labelEl = priceEl.querySelector(".ante-buy-label")
    
    if (comparePrice > price) {
      comparePriceEl.textContent = formatPrice(comparePrice)
      comparePriceEl.hidden = false
    } else {
      comparePriceEl.hidden = true
    }
    
    priceSpanEl.textContent = formatPrice(price)
    
    if (labelEl) {
      if (currentDefaultLabel) {
        labelEl.textContent = currentDefaultLabel
        labelEl.hidden = false
      } else {
        labelEl.hidden = true
      }
    }
  })

  document.querySelectorAll(".ante-buy-installments").forEach(e => {
    e.textContent = formatPrice(price / 4)
  })

  const savings = comparePrice - price
  document.querySelectorAll(".ante-buy-savings").forEach(e => {
    if (savings > 0) {
      e.innerHTML = `Save <strong>${formatPrice(savings)}</strong>`
      e.hidden = false
    } else {
      e.hidden = true
    }
  })
}

function setDefaultText(text) {
  globalDefaultText = text
  document.querySelectorAll("buy-button").forEach(btn => {
    btn.updateFromAttributes?.()
  })
}

function setDefaultLabel(text) {
  globalDefaultLabel = text
  if (lastLabelType === "global") {
    currentDefaultLabel = globalDefaultLabel
  }
  document.querySelectorAll("buy-button").forEach(btn => {
    btn.updateFromAttributes?.()
  })
  document.querySelectorAll(".ante-price.static:not(.ante-buy-button-price)").forEach(priceEl => {
    const labelEl = priceEl.querySelector(".ante-buy-label:not(.custom)")
    if (labelEl) {
      if (text) {
        labelEl.textContent = text
        labelEl.hidden = false
      } else {
        labelEl.hidden = true
      }
    }
  })
}

// Loader Button

class LoaderButton extends HTMLElement {
  static get observedAttributes() {
    return ["loading", "disabled"]
  }

  get loading() {
    return this.hasAttribute("loading")
  }

  set loading(value) {
    this.toggleAttribute("loading", !!value)
  }

  get disabled() {
    return this.hasAttribute("disabled")
  }

  set disabled(value) {
    this.toggleAttribute("disabled", !!value)
  }

  connectedCallback() {
    this.classList.add("ante-button")
    this.addEventListener("click", e => {
      if (this.loading || this.disabled) e.stopImmediatePropagation()
    }, true)
  }
}

customElements.define("loader-button", LoaderButton)

// Buy Button

class BuyButton extends LoaderButton {
  static get observedAttributes() {
    return [...super.observedAttributes, "price", "compare-price", "label", "text", "show-price"]
  }
  connectedCallback() {
    super.connectedCallback()
    this.classList.add("ante-buy-button")
    this.innerHTML = `
      <div class="ante-buy-button-text"></div>
      <div class="ante-price ante-buy-button-price">
        <span class="ante-buy-compare-price callout-price"><span></span></span>
        <div class="ante-buy-price callout-price"></div>
        <div class="ante-buy-label body-caption bold" hidden></div>
      </div>
      <div class="ante-buy-arrow" hidden>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="13" viewBox="0 0 21 13" fill="none">
          <path d="M10.9964 12.2276C10.6781 11.5235 11.2656 10.7621 11.7028 10.1463C12.0388 9.67285 12.4388 9.24836 12.8915 8.885C13.206 8.65053 13.5078 8.39939 13.7954 8.13265C11.2271 8.16303 5.60659 8.31091 2.96366 8.43899C1.29828 8.55918 1.00986 7.94457 0.978516 7.5063C1.04515 6.57361 1.41914 5.66356 2.524 5.53452C4.26328 5.33135 5.80145 5.25476 7.60005 5.21476C9.53188 5.17183 12.1925 5.12077 13.9817 5.01495C13.3237 4.55433 12.3379 4.02721 11.6478 3.61909C11.2928 3.40909 10.1847 2.94986 9.95241 2.25212C9.74193 1.61981 10.0932 0.153029 10.9174 0.223654C12.1031 0.325433 13.9762 1.58212 15.1377 2.13346C16.7261 2.94798 18.4839 3.63687 19.7706 4.90269C20.1238 5.32452 20.4063 5.9487 20.1349 6.46096C19.7503 7.18692 17.8575 8.84668 17.2725 9.33173C16.1202 10.2871 14.7544 11.57 13.495 12.5739C12.5427 13.333 11.2771 12.849 10.9964 12.2276Z" fill="currentColor"/>
        </svg>
      </div>
    `
    this.updateFromAttributes()
  }
  attributeChangedCallback(name) {
    super.attributeChangedCallback?.(name)
    this.updateFromAttributes()
  }
  updateFromAttributes() {
    setTimeout(() => {
      const textEl = this.querySelector(".ante-buy-button-text")
      const compareEl = this.querySelector(".ante-buy-compare-price")
      const compareElText = this.querySelector(".ante-buy-compare-price span")
      const priceEl = this.querySelector(".ante-buy-price")
      const labelEl = this.querySelector(".ante-buy-label")
      const priceContainer = this.querySelector(".ante-buy-button-price")
      const arrowEl = this.querySelector(".ante-buy-arrow")
      const price = this.getAttribute("price")
      const comparePrice = this.getAttribute("compare-price")
      const label = this.getAttribute("label") || currentDefaultLabel
      const text = this.getAttribute("text")
      const showPrice = this.hasAttribute("show-price")
      
      textEl.textContent = text || globalDefaultText
      textEl.classList.toggle("default", !text)
      
      if (label) {
        labelEl.textContent = label
        labelEl.hidden = false
      } else {
        labelEl.hidden = true
      }
      
      const finalPrice = parseFloat(price || globalDefaultPrice) || 0
      const finalComparePrice = parseFloat(comparePrice || globalDefaultComparePrice) || 0
      
      priceEl.textContent = formatPrice(finalPrice)

      if (finalComparePrice > finalPrice) {
        compareElText.textContent = formatPrice(finalComparePrice)
        compareEl.hidden = false
      } else {
        compareEl.hidden = true
      }

      if (showPrice) {
        priceContainer.hidden = false
        arrowEl.hidden = true
      } else {
        priceContainer.hidden = true
        arrowEl.hidden = false
      }
    }, 0)
  }
  setValues(price, comparePrice, label) {
    this.setAttribute("price", price)
    if (comparePrice) this.setAttribute("compare-price", comparePrice)
    if (label) this.setAttribute("label", label)
    else this.removeAttribute("label")
  }
}

customElements.define("buy-button", BuyButton)

// Tab Bars

function initTabBars() {
  const tabBars = document.querySelectorAll(".tab-bar:not(.initialised)")
  for (const tabBar of tabBars) {
    tabBar.classList.add("initialised")

    const buttons = tabBar.querySelectorAll(".tab-bar-button")
    const contentsWrap = tabBar.nextElementSibling?.classList.contains("tab-contents")
      ? tabBar.nextElementSibling
      : null
    if (!contentsWrap) continue

    const contents = Array.from(contentsWrap.querySelectorAll(".tab-content"))

    for (const button of buttons) {
      button.addEventListener("click", () => {
        if (button.classList.contains("active")) return

        const currentActive = tabBar.querySelector(".tab-bar-button.active")
        if (currentActive) currentActive.classList.remove("active")

        const activeContent = contentsWrap.querySelector(".tab-content.active")
        const border =
          parseFloat(getComputedStyle(contentsWrap).borderTopWidth) +
          parseFloat(getComputedStyle(contentsWrap).borderBottomWidth)

        contentsWrap.style.height = activeContent
          ? activeContent.offsetHeight + border + "px"
          : border + "px"

        button.classList.add("active")
        const target = button.textContent.trim()
        contents.forEach(c => c.classList.toggle("active", c.dataset.tab === target))

        contentsWrap.classList.add("transitioning")
        const newContent = contentsWrap.querySelector(".tab-content.active")
        contentsWrap.style.height = newContent
          ? newContent.offsetHeight + border + "px"
          : border + "px"

        const duration = parseFloat(getComputedStyle(contentsWrap).getPropertyValue("--tabs-transition-duration")) * 1000
        setTimeout(() => {
          contentsWrap.classList.remove("transitioning")
        }, duration)

        tabBar.dispatchEvent(new CustomEvent("tab-changed", {
          detail: button.textContent
        }))
      })
    }

    const initial = contentsWrap.querySelector(".tab-content.active")
    const border =
      parseFloat(getComputedStyle(contentsWrap).borderTopWidth) +
      parseFloat(getComputedStyle(contentsWrap).borderBottomWidth)

    contentsWrap.style.height = initial
      ? initial.offsetHeight + border + "px"
      : border + "px"
  }
}

// Dynamic Marquee

function initMarquees() {
  const marquees = document.querySelectorAll(".marquee:not(.initialised)")
  for (const marquee of marquees) {
    const div = document.createElement("div")
    div.className = "marquee-sub"
    div.append(...marquee.children)
    marquee.append(div)

    const measure = div.cloneNode(true)
    measure.classList.add("marquee-measure")
    marquee.append(measure)

    const pxPerSec = marquee.dataset.speed ? parseFloat(marquee.dataset.speed) : 128
    let lastWidth = marquee.clientWidth

    function adjust() {
      const base = marquee.querySelector(".marquee-sub")
      const measureWidth = measure.clientWidth
      const needClones = Math.ceil(marquee.clientWidth / measureWidth)

      const clones = marquee.querySelectorAll(".marquee-sub.clone")
      const current = clones.length

      if (current > needClones) {
        for (let i = needClones; i < current; i++) clones[i].remove()
      } else if (current < needClones) {
        for (let i = current; i < needClones; i++) {
          const clone = base.cloneNode(true)
          clone.classList.add("clone")
          marquee.insertBefore(clone, measure)
        }
      }

      const duration = measureWidth / pxPerSec
      marquee.querySelectorAll(".marquee-sub").forEach(sub => {
        sub.style.animation = "none"
        void sub.offsetWidth
        sub.style.animation = `marquee ${duration}s linear infinite`
      })

      if (!("infinite" in marquee.dataset)) {
        marquee.classList.toggle("scrolling", measureWidth > marquee.clientWidth)
      }

      lastWidth = marquee.clientWidth
    }

    setTimeout(adjust, 0)
    window.addEventListener("resize", () => {
      if (marquee.clientWidth !== lastWidth) adjust()
    })

    marquee.classList.add("initialised")

    if ("infinite" in marquee.dataset) marquee.classList.add("scrolling")

    if ("pausable" in marquee.dataset) {
      let paused = false
      const pause = () => marquee.classList.add("paused")
      const resume = () => marquee.classList.remove("paused")

      marquee.addEventListener("mouseenter", pause)
      marquee.addEventListener("mouseleave", () => {
        paused = false
        resume()
      })

      marquee.addEventListener("touchstart", () => {
        paused = !paused
        if (paused) pause()
        else resume()
      })
    }

    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("img[loading='lazy']").forEach(img => {
            img.loading = "eager"
          })
          observer.unobserve(entry.target)
        }
      }
    })
    observer.observe(marquee)
  }
}

document.addEventListener("shopify:section:load", initMarquees)

// Custom Select

class CustomSelect extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => {
      this.tabIndex = 0
      this.options = Array.from(this.querySelectorAll("option")).map(o => ({
        value: o.value,
        text: o.textContent
      }))
      this.value = this.getAttribute("value") ?? this.options[0]?.value

      const current = this.options.find(o => o.value === this.value)

      this.button = document.createElement("div")
      this.button.className = "select-button"
      this.button.innerHTML = `
        <div class="select-label">
          ${this.options
            .map(
              o => `<span${o.value === this.value ? ' class="active"' : ""}>${o.text}</span>`
            )
            .join("")}
        </div>
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
        </svg>
      `
      this.innerHTML = ""
      this.append(this.button)

      this.button.addEventListener("click", e => {
        e.stopPropagation()
        if (CustomSelect.active === this) this.close()
        else this.open()
      })

      this.addEventListener("keydown", e => {
        if (!CustomSelect.active) {
          if (e.key === " " || e.key === "Enter") {
            e.preventDefault()
            this.open()
          }
        } else if (CustomSelect.active === this) {
          if (["Tab", "ArrowDown", "ArrowUp", "Enter", "Escape"].includes(e.key)) {
            e.preventDefault()
            this.handleNavigation(e)
          }
        }
      })
    })
  }

  open() {
    this.closeAll()
    this.button.classList.add("active")
    this.drop = document.createElement("div")
    this.drop.className = "select-drop"
    this.drop.innerHTML = this.options
      .map(o => `<div tabindex="-1" data-value="${o.value}">${o.text}</div>`)
      .join("")
    this.append(this.drop)
    this.items = Array.from(this.drop.children)
    this.items.forEach(div =>
      div.addEventListener("click", e => this.selectValue(e.currentTarget.dataset.value))
    )
    this.hasFocused = false
    CustomSelect.active = this
  }

  handleNavigation(e) {
    const i = this.items.indexOf(document.activeElement)

    if (!this.hasFocused && ["Tab", "ArrowDown", "ArrowUp"].includes(e.key)) {
      this.hasFocused = true
      const currentIndex = this.options.findIndex(o => o.value === this.value)
      if (currentIndex !== -1) this.items[currentIndex].focus()
      return
    }

    if (e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) {
      const next = i === -1 ? 0 : (i + 1) % this.items.length
      this.items[next].focus()
    } else if (e.key === "ArrowUp" || (e.key === "Tab" && e.shiftKey)) {
      const prev = i === -1 ? this.items.length - 1 : (i - 1 + this.items.length) % this.items.length
      this.items[prev].focus()
    } else if (e.key === "Enter") {
      const el = this.items.find(e => e === document.activeElement)
      if (el) this.selectValue(el.dataset.value)
      else this.close()
    } else if (e.key === "Escape") {
      this.close()
    }
  }

  selectValue(value) {
    this.value = value
    const label = this.button.querySelector(".select-label")
    label.querySelectorAll("span").forEach(span =>
      span.classList.toggle("active", span.textContent === this.options.find(o => o.value === value).text)
    )
    this.dispatchEvent(new Event("input", { bubbles: true }))
    this.dispatchEvent(new Event("change", { bubbles: true }))
    this.close()
  }

  close() {
    if (this.drop) this.drop.remove()
    this.button.classList.remove("active")
    CustomSelect.active = undefined
  }

  closeAll() {
    if (CustomSelect.active) CustomSelect.active.close()
  }

  get value() {
    return this._value
  }

  set value(v) {
    this._value = v
    this.setAttribute("value", v)
  }
}

document.addEventListener("click", () => {
  if (CustomSelect.active) CustomSelect.active.close()
})

customElements.define("custom-select", CustomSelect)

addEventListener("DOMContentLoaded", () => {
  // Installment Prices

  document.querySelectorAll(".ante-buy-installments").forEach(e => {
    e.textContent = formatPrice(globalDefaultPrice / 4)
  })

  // Page Width

  function updatePageWidth() {
    document.documentElement.style.setProperty("--ante-page-width", `${document.documentElement.clientWidth}px`)
    document.documentElement.style.setProperty("--ante-container-width", `min(var(--content-width), ${document.documentElement.clientWidth}px - var(--section-horizontal-padding) * 2)`)
  }
  
  updatePageWidth()
  window.addEventListener("resize", updatePageWidth)

  // Smooth scrolling
  
  const nav = document.getElementById("ante-lander-nav")

  window.getStickyTop = () => {
    const styles = getComputedStyle(document.body)
    const anteHeaderHeight = parseFloat(styles.getPropertyValue("--ante-header-height"))
    const sectionHorizontalPadding = parseFloat(styles.getPropertyValue("--section-horizontal-padding"))
    if (nav.classList.contains("nav-type-floating") || nav.classList.contains("nav-type-floating_separate_logo")) {
      return anteHeaderHeight + Math.min(40, sectionHorizontalPadding) * 2
    } else {
      return anteHeaderHeight + Math.min(40, sectionHorizontalPadding)
    }
  }

  window.smoothScroll = element => {
    let attempts = 0
    let lastTop = null

    function scroll() {
      const top = element.getBoundingClientRect().top + window.scrollY - getStickyTop()
      if (lastTop !== null && Math.abs(top - lastTop) < 2) return
      lastTop = top

      window.scrollTo({ top, behavior: "smooth" })
      attempts++
      if (attempts < 4) setTimeout(scroll, 500)
    }

    scroll()
  }

  // Anchor id smooth scrolling

  document.body.addEventListener("click", e => {
    const link = e.target.closest("a[href^='#']")
    if (!link) return

    const id = link.getAttribute("href").slice(1)
    if (!id) return

    const target = document.getElementById(id)
    if (!target) return

    e.preventDefault()
    smoothScroll(target)
  })

  // Modals

  const modals = document.createElement("div")
  modals.id = "modals"
  document.body.append(modals)

  function makeModal(title, content, id) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    container.setAttribute("tabindex", "-1")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <button class="modal-close">
            <svg width="28" height="28" viewBox="0 0 24 24"><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>
          </button>
        </div>
        <div class="modal-contents"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content.map(node => node.cloneNode(true)))
    }
    return container
  }

  function handleModal(modal, close, func) {
    modal.querySelector(".modal-title-row .modal-close").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modal.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        close()
      } else if (e.key === "Tab") {
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    })
    modals.append(modal)
    if (func) {
      const modalElement = modal.querySelector(".modal-element")
      modalElement.close = close
      func(modalElement)
    }
  }

  function openModal(title, content, id, func) {
    console.log(title, content, id)
    const modal = makeModal(title, content, id)
    function close() {
      modal.classList.remove("open")
      setTimeout(() => {
        modal.remove()
        const all = modals.querySelectorAll(".modal-container")
        if (all.length) {
          all[all.length - 1].focus()
        }
      }, 150)
    }
    handleModal(modal, close, func)
    setTimeout(() => {
      modal.classList.add("open")
      const focusable = modal.querySelectorAll(
        'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      if (focusable.length > 1) {
        focusable[1].focus()
      } else {
        modal.focus()
      }
    }, 0)
  }

  document.querySelectorAll(".modal").forEach(e => {
    e._modalData = {
      title: e.dataset.title,
      content: [...e.children],
      id: e.dataset.modalId ?? e.dataset.trigger + "-modal"
    }
  })

  document.addEventListener("click", e => {
    document.querySelectorAll(".modal").forEach(el => {
      if (e.target.closest(`.${el.dataset.trigger}`)) {
        openModal(el._modalData.title, el._modalData.content, el._modalData.id)
      }
    })
  })

  document.querySelectorAll("[data-modal]").forEach(el => {
    el.addEventListener("click", () => {
      openModal(
        el.dataset.modalTitle,
        el.dataset.modal,
        el.dataset.modalId
      )
    })
  })

  window.showModal = (title, content, func, id) => {
    openModal(title, content, id, func)
  }

  // Newsletter

  if (location.search.includes("customer_posted=true") && location.hash === "#newsletter") {
    showModal("Signed up!", "Thanks for subscribing to our newsletter!")
    const url = new URL(location)
    url.searchParams.delete("customer_posted")
    history.replaceState(null, "", url.pathname + url.search)
  }

  // Inits

  initMarquees()
  initTabBars()
})